import { combineReducers } from "redux";
import commonReducer from "@frameworks/web/redux/feature/Markets/Common/Reducers/commonReducer";
import MFOrderBookReducer from "./mfOrderBook";
export default combineReducers({
    reducersData: MFOrderBookReducer,
    commonData: commonReducer,
});
